// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__+1sFc","welcoming__text":"styles_welcoming__text__wwZ7R","date-time__text":"styles_date-time__text__ndnM+"};